<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/daily-transaction'">Daily Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/monthly-transaction'">Monthly Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/yearly-transaction'">Yearly Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/transaction'">Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/withdraw-transaction'">Withdraw Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/my-transaction'">My Transaction List</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/refund'">Refund List</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                           <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/withdraw-transaction'">Withdraw Transaction List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/transaction'">Transaction List</li>
                            <li class="breadcrumb-item active text-capitalize" aria-current="page" *ngIf="CurrentUrl=='/my-transaction'"  (click)="service.back()">{{userNames}}</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/refund'">Refund List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/daily-transaction'">Daily Transaction List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/monthly-transaction'">Monthly Transaction List</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/yearly-transaction'">Yearly Transaction List</li>
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row align-items-end" >
                <div class="col-12 col-sm-4 col-lg-3 pb-3">
                    <label for="inputState" class="form-label">Search By Name</label>
                    <input type="text" id="inputState" class="form-control" placeholder="Search By Name" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>               
                <div class="col-12 col-sm-4 col-lg-3 pb-3 pt-sm-4">
                    <button type="button" class="btn custom-btn btn-danger px-4" (click)="reset()">Reset</button>
                </div>
                
                <div class="col-12" >
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Full Name</th>
                                        <th scope="col">Eamil</th>
                                        <th scope="col" *ngIf="CurrentUrl !='/withdraw-transaction'">Subscription Id</th>
                                        <th scope="col" *ngIf="CurrentUrl =='/withdraw-transaction'">Points</th>
                                        <th scope="col">Transaction Date</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td>{{item.userData.fullName}} </td>
                                        <td>{{item.userData.email}}</td>                                        
                                        <td *ngIf="CurrentUrl !='/withdraw-transaction'">{{item.productId}}</td>  
                                        <td *ngIf="CurrentUrl =='/withdraw-transaction'">{{item.points}}</td>                                     
                                        <td>{{service.dateCon(item.createdAt)}}</td>
                                        <td *ngIf="CurrentUrl !='/withdraw-transaction'">{{service.currency}}{{item.amount}}</td>
                                        <td *ngIf="CurrentUrl =='/withdraw-transaction'">{{service.currency}}{{item.response.payout.amount}}</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
            <!--end row-->





        </div>
    </div>
    <app-footer></app-footer>
</div>